import qs from 'qs';

export const APP_DOWNLOAD_LINK = 'https://neowizholdem.onelink.me/QMq2/9cmquifc';

export const YOUTUBE_LINK = 'https://www.youtube.com/@PmangPokers';

export const KAKAO_LINK = 'https://open.kakao.com/o/gOf2qp8e';

export const APL_LINK = 'https://acepokerleague.com/apl-x-p1-osaka-2026/';

export const CLOSE_SCHEME = 'npsusl://onWebViewClose';

export const PFGT_LINK = 'https://kphf.co.kr/pro';

export const DETAIL_LINK = 'https://www.youtube.com/@PmangPokers/posts';

const OPEN_BROWSER_SCHEME = 'npsusl://onOpenBrowser';

const TOURNAMENT_SCHEME = 'ChannelTntAll';

export const parseQueryString = () => {
  // HashRouter를 사용하는 경우 해시 뒤의 쿼리 파라미터를 파싱
  let searchString = location.search;

  // 해시가 있고 해시 뒤에 쿼리 파라미터가 있는 경우
  if (location.hash && location.hash.includes('?')) {
    searchString = location.hash.split('?')[1];
    searchString = '?' + searchString;
  }

  const qs = new URLSearchParams(searchString);

  const gsn = Number(qs.get('gsn')) || 0;
  const hash = qs.get('hash') || 'webtech';
  const hci = qs.get('hci') || '';
  const storeType = qs.get('store_type') || qs.get('store') || qs.get('storeType') || '';

  const subPath = location.pathname;
  const defaultCode = subPath.slice(1).replace('.html', '');
  const code = qs.get('code') || defaultCode;
  const v = qs.get('v') || '';

  return {
    gsn,
    hash,
    storeType,
    code,
    hci,
    v,
  };
};

export const isPc = () => {
  const { storeType } = parseQueryString();
  if (storeType === 'p') return true;
  if (storeType === 'i') return false; // ios
  if (storeType === 'g') return false; // google
  if (storeType === 't') return false; // tstore
  if (storeType === 'gb') return false; // 구글
  if (storeType === 'gk') return false; // 구글 카카오
  if (storeType === 's') return false; // 삼성 스토어
  if (storeType === 'w') return false;
  if (storeType === 'gpg') return false;
  return true;
};

export const createBaseParams = (entryGroupSrl?: number, ticketNo?: number) => {
  const params = parseQueryString();
  const newParams: Record<string, string | number> = { ...params };

  if (entryGroupSrl) {
    newParams.entryGroupSrl = entryGroupSrl;
  }
  if (ticketNo) {
    newParams.ticketNo = ticketNo;
  }

  return qs.stringify(newParams);
};

const API_ENDPOINTS = {
  dev: 'https://hdt-wic-qa.pmang.com',
  qa: 'https://hdt-wic-qa.pmang.com',
  tq: 'https://hdt-wic-tq.pmang.com',
  review: 'https://hdt-wic-review.pmang.com',
  centum: 'https://hdt-wic-centum.pmang.com',
  live: 'https://hdt-wic.pmang.com',
} as const;

export const getEnv = () => {
  const subPath = location.pathname;

  if (subPath.includes('/qa/')) return 'qa';
  if (subPath.includes('/tq/')) return 'tq';
  if (subPath.includes('/review/')) return 'review';
  if (subPath.includes('/centum/')) return 'centum';
  if (subPath.includes('/live/')) return 'live';

  return 'dev';
};

export const getApiEndPoint = () => {
  const env = getEnv();
  return API_ENDPOINTS[env];
};

export const goToTournament = () => {
  window.location.href = `${CLOSE_SCHEME}?reload=${TOURNAMENT_SCHEME}`;
};

export const closeWebview = () => {
  window.location.assign(CLOSE_SCHEME);
};

export const goToPFGT = () => {
  window.location.href = `${OPEN_BROWSER_SCHEME}?url=${PFGT_LINK}`;
};

export const openAppDownloadLink = () => {
  window.gtag('event', 'app_download', {
    event_category: 'click',
    event_label: 'app-download',
  });
  if (isPc()) {
    window.open(APP_DOWNLOAD_LINK, '_blank');
    return;
  }
  window.location.href = APP_DOWNLOAD_LINK;
};

export const openYoutubeLink = () => {
  if (isPc()) {
    window.open(YOUTUBE_LINK, '_blank');
    return;
  }
  window.location.href = `${OPEN_BROWSER_SCHEME}?url=${YOUTUBE_LINK}`;
};

export const openDetailLink = () => {
  if (isPc()) {
    window.open(DETAIL_LINK, '_blank');
    return;
  }
  window.location.href = `${OPEN_BROWSER_SCHEME}?url=${DETAIL_LINK}`;
};

export const getQrUrl = (qr: string, tnmtScheduleSrl: number) => {
  const { gsn } = parseQueryString();
  const ticketUrl = location.href.split('?')[0].replace('index.html', 'ticket.html');

  return `${ticketUrl}?hash=${qr}&gsn=${gsn}&tnmtScheduleSrl=${tnmtScheduleSrl}`;
};

export const mobileQuery = '@media screen and (max-width: 1000px)';

export const openKakaoLink = () => {
  if (isPc()) {
    window.open(KAKAO_LINK, '_blank');
    return;
  }
  window.location.href = `${OPEN_BROWSER_SCHEME}?url=${KAKAO_LINK}`;
};

export const openAplLink = () => {
  if (isPc()) {
    window.open(APL_LINK, '_blank');
    return;
  }
  window.location.href = `${OPEN_BROWSER_SCHEME}?url=${APL_LINK}`;
};
